/**
 * Every admin permission, across all services. Each service declares and enforces its own in
 * `src/Enum/admin-permission.enum.ts` (users, funding, payment); this list is their union. The app
 * uses it to hide what the admin's role does not allow, and to build the role permissions tree.
 */
export enum EAdminPermission {
  VIEW_DASHBOARD = 'VIEW_DASHBOARD',

  LIST_ADMINS = 'LIST_ADMINS',
  VIEW_ADMIN = 'VIEW_ADMIN',
  CREATE_ADMIN = 'CREATE_ADMIN',
  UPDATE_ADMIN = 'UPDATE_ADMIN',
  DELETE_ADMIN = 'DELETE_ADMIN',

  LIST_ROLES = 'LIST_ROLES',
  VIEW_ROLE = 'VIEW_ROLE',
  CREATE_ROLE = 'CREATE_ROLE',
  UPDATE_ROLE = 'UPDATE_ROLE',
  DELETE_ROLE = 'DELETE_ROLE',

  LIST_USERS = 'LIST_USERS',
  VIEW_USER = 'VIEW_USER',
  BLACKLIST_USER = 'BLACKLIST_USER',
  UPDATE_USER_ACCESS = 'UPDATE_USER_ACCESS',

  LIST_SUBSCRIPTIONS = 'LIST_SUBSCRIPTIONS',
  VIEW_SUBSCRIPTION = 'VIEW_SUBSCRIPTION',
  VERIFY_SUBSCRIPTION = 'VERIFY_SUBSCRIPTION',
  ACCEPT_SUBSCRIPTION = 'ACCEPT_SUBSCRIPTION',
  REJECT_SUBSCRIPTION = 'REJECT_SUBSCRIPTION',

  LIST_TRANSACTIONS = 'LIST_TRANSACTIONS',
  VIEW_TRANSACTION = 'VIEW_TRANSACTION',
  APPROVE_TRANSACTION = 'APPROVE_TRANSACTION',
  REJECT_TRANSACTION = 'REJECT_TRANSACTION',

  LIST_APPLICATIONS = 'LIST_APPLICATIONS',
  VIEW_APPLICATION = 'VIEW_APPLICATION',

  LIST_MASRI_CREDIT_REPORTS = 'LIST_MASRI_CREDIT_REPORTS',
  VIEW_MASRI_CREDIT_REPORT = 'VIEW_MASRI_CREDIT_REPORT',

  LIST_RATINGS = 'LIST_RATINGS',
  VIEW_RATING = 'VIEW_RATING',

  LIST_PAYMENT_TRANSACTIONS = 'LIST_PAYMENT_TRANSACTIONS',

  LIST_TRANSACTION_CATEGORIES = 'LIST_TRANSACTION_CATEGORIES',
  VIEW_TRANSACTION_CATEGORY = 'VIEW_TRANSACTION_CATEGORY',
  CREATE_TRANSACTION_CATEGORY = 'CREATE_TRANSACTION_CATEGORY',
  UPDATE_TRANSACTION_CATEGORY = 'UPDATE_TRANSACTION_CATEGORY',
  DELETE_TRANSACTION_CATEGORY = 'DELETE_TRANSACTION_CATEGORY',

  VIEW_INTEREST_RATE_BRACKET = 'VIEW_INTEREST_RATE_BRACKET',
  UPDATE_INTEREST_RATE_BRACKET = 'UPDATE_INTEREST_RATE_BRACKET',

  VIEW_PRICES = 'VIEW_PRICES',
  UPDATE_PRICES = 'UPDATE_PRICES',
}

/** Held only by the seeded super admin role; grants everything (see AuthUserModel.can). */
export const SUPER_ADMIN_PERMISSION = 'SUPER_ADMIN';
